import group from "@Images/NewUI/Group.png";
import "@Styles/mandate.css";
import React, { useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import OtpInput from "react-otp-input";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "semantic-ui-react";
import { setNewMpin, signInUser } from "../../../../Redux/Authenticate/action";
import Heading from "../../Common/MainHeading";
import { HEADING_CHANGEMPIN } from "../../Common/constant";
const ChangeYourMpin = (props) => {
  const navigate = useNavigate();
  const [oldPin, setOldPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [errors, setErrors] = useState();
  const token = props?.user?.manual_token||localStorage.getItem("gpay_token");
  /* istanbul ignore next */
  const handleSubmit = (e) => {
    if (oldPin.length !== 6) {
      setErrors({ ...errors, oldPin: "pin must be 6 digits" });
      return;
    }
    if (newPin.length !== 6) {
      setErrors({ ...errors, newPin: "pin must be 6 digits" });
      return;
    }
    if (confirmPin.length !== 6) {
      setErrors({ ...errors, confirmPin: "pin must be 6 digits" });
      return;
    }
    if (confirmPin !== newPin) {
      setErrors({
        ...errors,
        confirmPin: "new MPIN and confirm MPIN dosen't Match",
      });
      return;
    }
    let data = {
      phone_number: props.user.phone_number,
      mpin: parseInt(oldPin),
    };
    props
      .signInUser(data)
      .then((res) => {
        // console.log("res", res);
        if (res.status === 200) {
          props
            .setNewMpin(token, confirmPin)
            .then((response) => {
              // console.log("hjgfdhgjhkjghfgdfhgj", response);
              navigate("/profile_menu");
            })
            .catch((err) => {
              setLoader(false);
              if (err.response?.status === 401) {
               window.location.href = "/";
          localStorage.removeItem("gpay_token");
              }
              let error = err?.response?.data?.error;
              ToastMsg(error, "error");
              // console.log(err);
            });
        }
        if (res.status === 203) {
          setErrors({ ...errors, backend: res?.data?.error });
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };
  return (
    <div className="main_div">
      <div className="container">
        <div className="pb-4">
          <Heading
            headingText={HEADING_CHANGEMPIN}
            backprops={"/DummyDashboard"}
            history={props.history}
          />
          <div className="wrapper-content">
            <div className="card-height px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg">
              <div className="h-100 d-flex flex-column justify-content-between change-pin">
                <div className="pt-4 pb-5">
                  <img
                    src={group}
                    style={{ width: 115, height: 106 }}
                    // className="mobile_img_c"
                    alt="PaymeIndia"
                  />
                </div>
                <Form>
                  <Form.Field className="pt-3 mb-3">
                    <label className="main__page font-size-18" name="otp">
                      Old MPIN
                    </label>
                    <div>
                      <OtpInput
                        containerStyle="otpCover"
                        value={oldPin}
                        onChange={(e) => {
                          setOldPin(e);
                          setErrors({ ...errors, oldPin: "" });
                        }}
                        numInputs={6}
                        inputType="number"
                        renderSeparator={<span></span>}
                        renderInput={(props) => <input {...props} />}
                      />
                      <span style={{ color: "red" }}>{errors?.oldPin}</span>
                    </div>
                  </Form.Field>
                  <Form.Field className="pt-3 mb-3">
                    <label className="main__page font-size-18" name="otp">
                      New MPIN
                    </label>
                    <div>
                      <OtpInput
                        containerStyle="otpCover"
                        value={newPin}
                        onChange={(e) => {
                          setNewPin(e);
                          setErrors({ ...errors, newPin: "" });
                        }}
                        numInputs={6}
                        inputType="number"
                        renderSeparator={<span></span>}
                        renderInput={(props) => <input {...props} />}
                      />
                      <span style={{ color: "red" }}>{errors?.newPin}</span>
                    </div>
                  </Form.Field>
                  <Form.Field className="pt-3 mb-3">
                    <label className="main__page font-size-18" name="otp">
                      Confirm new MPIN
                    </label>
                    <div>
                      <OtpInput
                        containerStyle="otpCover"
                        value={confirmPin}
                        onChange={(e) => {
                          setConfirmPin(e);
                          setErrors({ ...errors, confirmPin: "" });
                        }}
                        numInputs={6}
                        inputType="number"
                        renderSeparator={<span></span>}
                        renderInput={(props) => <input {...props} />}
                      />
                      <span style={{ color: "red" }}>{errors?.confirmPin}</span>
                    </div>
                    <span style={{ color: "red" }}>{errors?.backend}</span>
                  </Form.Field>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center pt-4">
          <button
            type="button"
            onClick={handleSubmit}
            className="btn jigbuttonModeltwo bg-orange text-white rounded-pill px-5 py-3 mb-3"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  // console.log("state", state);
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps, {
  signInUser,
  setNewMpin,
})(ChangeYourMpin);
